import classNames from "classnames";

export const Biodata = ({ setAgegroup, setGender, bioData }) => {
    return (
        <div>
            <div className={classNames("data-unit")}>
                <div onChange={setAgegroup}>
                    <div className="grp-label">What's your age group?</div>
                    <div className="radio-input">
                        <input
                            type="radio"
                            value={"10 to 14"}
                            checked={bioData.agegroup === "10 to 14"}
                            name="child"
                            readOnly
                        />
                        <label htmlFor="child">10 to 14</label>
                    </div>

                    <div className="radio-input">
                        <input
                            type="radio"
                            value={"15 to 19"}
                            checked={bioData.agegroup === "15 to 19"}
                            name="teen"
                            readOnly
                        />
                        <label htmlFor="teen">15 to 19</label>
                    </div>
                    <div className="radio-input">
                        <input
                            type="radio"
                            value={"20 to 24"}
                            checked={bioData.agegroup === "20 to 24"}
                            name="adult"
                            readOnly
                        />
                        <label htmlFor="adult">20 to 24</label>
                    </div>
                    <h3 className="bio-data">{bioData?.agegroup}</h3>
                </div>
                <div onChange={setGender}>
                    <div className="grp-label">What's your gender?</div>
                    <div className="radio-input">
                        <input
                            type="radio"
                            value={"Male"}
                            checked={bioData.gender === "Male"}
                            name="group 3"
                            readOnly
                        />
                        <label htmlFor="group 3">Male</label>
                    </div>

                    <div className="radio-input">
                        <input
                            type="radio"
                            value={"Female"}
                            checked={bioData.gender === "Female"}
                            name="group 4"
                            readOnly
                        />
                        <label htmlFor="group 4">Female</label>
                    </div>
                    <h3 className="bio-data">{bioData?.gender}</h3>
                </div>
            </div>
        </div>
    )
} 